import React from "react";

const FormInputSelectComponent = ({
  label,
  id,
  name,
  value,
  placeholder,
  error,
  options,
  onChange,
  isRequired = false,
  isVertical = false,
  isDisabled = false,
  onKeyDown,
}) => {
  // console.log({ options });
  const handleChange = (e) => {
    if (onChange) onChange(e.target.value);
  };
  const handleKeyDown = (e) => {
    // console.log(e.keyCode);
    if (onKeyDown) onKeyDown({ keyCode: e.keyCode });
  };
  return (
    <div className="col-12">
      <div className={isVertical ? "" : "mb-1 row"}>
        {label && (
          <div className={isVertical ? "col-sm-12" : "col-sm-2"}>
            <label className="col-form-label">
              {label}
              {isRequired && <> * </>}
            </label>
          </div>
        )}

        <div className={isVertical ? "col-sm-12" : "col-sm-10"}>
          <select
            className={`form-select ${error ? "is-invalid" : ""}`}
            name={name}
            id={id}
            onKeyDown={handleKeyDown}
            onChange={handleChange}
            placeholder={placeholder}
            disabled={isDisabled}
          >
            <option value={""}> - {placeholder} - </option>
            {options.map((option) => (
              <option
                selected={`${option.value == value ? "selected" : ""}`}
                value={option.value}
              >
                {option.name}
              </option>
            ))}
          </select>
          {error && <div className="invalid-feedback">{error}</div>}
        </div>
      </div>
    </div>
  );
};

export default FormInputSelectComponent;
